module.exports = __webpack_public_path__ + "img/mu.50dccf5c.svg";